<form (ngSubmit)="onSubmit($event)" 
    name="editOrgForm"
	*ngIf="selectedOrganization && selectedOrganization.name != null">
    <div class="inner-sub-border mt-2">
        <span class="subinner-subtit">{{ _organizationService.legendText }}</span>
        <div class="form-group" *ngIf="isHuronAdmin()">
            <label for="allowImpersonation">
                <input 
                    type="checkbox" 
                    [(ngModel)]="currentClient.allowImpersonation" 
                    [checked]="currentClient.allowImpersonation" 
                    name="allowImpersonation" 
                    id="allowImpersonation"
                    (change)="onEdited()">
                Allow Impersonation
            </label>
        </div>
        <div class="form-group"  *ngIf="isHuronAdmin()">
            <label for="forceTLSWhenSendingEmail">
                <input 
                    type="checkbox" 
                    name="forceTLSWhenSendingEmail" 
                    id="forceTLSWhenSendingEmail" 
                    [checked]="currentClient.forceTLSWhenSendingEmail" 
                    [disabled]="!isHuronAdmin()" 
                    [(ngModel)]="currentClient.forceTLSWhenSendingEmail"
                    (change)="onEdited()">
                Force TLS When Sending Email
            </label>
        </div>
        <div class="form-group" *ngIf="isHuronAdmin()">
            <span class="label" for="legacyLink">Legacy Link Name</span>
            <input #legacyLink #legacyLinkName="ngModel"
                type="text"             
                [ngModel]="selectedOrganization.legacyLink" 
                (ngModelChange)="selectedOrganization.legacyLink = $event;onEdited()"                
                name="legacyLink" 
                id="selectedOrganization.legacyLink" 
                pattern="^[a-zA-Z0-9-_]*$" 
                (change)="selectedOrganization.legacyLink = selectedOrganization.legacyLink.trim()"
                required>
            <span *ngIf="showEditOrganizationError(legacyLink)" class="validation-error">Legacy Link Name is required and cannot contain spaces or special characters.</span>
        </div>
        <div class="form-group" *ngIf="isHuronAdmin()">
            <span class="label" for="code">Kentico Id</span>
            <input #code 
                type="text" 
                [ngModel]="selectedOrganization.code"
                (ngModelChange)="selectedOrganization.code = $event;onEdited()" 
                name="code" 
                id="selectedOrganization.code" 
                (change)="selectedOrganization.code = selectedOrganization.code.trim()"
                required>
            <span *ngIf="showEditOrganizationError(code)" class="validation-error">Kentico Id is required.</span>
        </div>
        <div class="form-group" *ngIf="!showMinimumFields">
            <div class="row">
                <div class="col-1">
                    <span class="label" for="isPCMAuthorized">PCM Authorized?</span>
                    <input #isPCMAuthorized 
                        class="mr-2"
                        type="checkbox" 
                        [ngModel]="selectedOrganization.isDcmAuthorized"
                        (ngModelChange)="selectedOrganization.isDcmAuthorized = $event" 
                        name="isPCMAuthorized"
                        id="selectedOrganization.isDcmAuthorized">
                    <span *ngIf="showEditOrganizationError(isPCMAuthorized)" class="validation-error">Invalid</span>
                </div>
                <div class="col-1">
                    <span class="label" for="isLEMAuthorized">LEM Authorized?</span>
                    <input #isLEMAuthorized 
                        class="mr-2"
                        type="checkbox" 
                        [ngModel]="selectedOrganization.isLemAuthorized"
                        (ngModelChange)="selectedOrganization.isLemAuthorized = $event" 
                        name="isLemAuthorized"
                        id="selectedOrganization.isLemAuthorized">
                    <span *ngIf="showEditOrganizationError(isLemAuthorized)" class="validation-error">Invalid</span>
                </div>
                <div class="col-1">
                    <span class="label" for="isPFSAuthorized">PFS Authorized?</span>
                    <input #isPFSAuthorized 
                        class="mr-2"
                        type="checkbox" 
                        [ngModel]="selectedOrganization.isPFSAuthorized"
                        (ngModelChange)="selectedOrganization.isPFSAuthorized = $event" 
                        name="isPFSAuthorized"
                        id="selectedOrganization.isPFSAuthorized">
                    <span *ngIf="showEditOrganizationError(isPFSAuthorized)" class="validation-error">Invalid</span>
                </div>
            </div>
            <div class="row">
                <div class="col-1">
                    <span class="label" for="parentOrganizationId">Parent Organization Name</span>
                    <div>{{selectedOrganization.parentOrganizationName}}</div>
                </div>
                <div class="col-1">
                    <span class="label" for="abbreviation">Abbreviation</span>
                    <input #abbreviation 
                        class="mr-2" 
                        type="text" 
                        [ngModel]="selectedOrganization.abbreviation"
                        (ngModelChange)="selectedOrganization.abbreviation = $event" 
                        name="abbreviation"
                        id="selectedOrganization.abbreviation">
                    <span *ngIf="showEditOrganizationError(abbreviation)" class="validation-error">Invalid</span>
                </div>
            </div>
            <div class="inner-sub-border mt-2">
                <span class="subinner-subtit">Address</span>
                <div class="row">
                    <div class="col-2">
                        <span class="label" for="address1">Address1</span>
                        <input #address1 
                            type="text" 
                            [ngModel]="selectedOrganization.address1"
                            (ngModelChange)="selectedOrganization.address1 = $event" 
                            name="address1" 
                            id="selectedOrganization.address1">
                        <span *ngIf="showEditOrganizationError(address1)" class="validation-error">Invalid</span>
                    </div>
                    <div class="col-2">
                        <span class="label" for="address2">Address2</span>
                        <input #address2  
                            type="text" 
                            [ngModel]="selectedOrganization.address2"
                            (ngModelChange)="selectedOrganization.address2 = $event" 
                            name="address2" 
                            id="selectedOrganization.address2">
                        <span *ngIf="showEditOrganizationError(address2)" class="validation-error">Invalid</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <span class="label" for="city">City</span>
                        <input #city 
                            class="mr-2" 
                            type="text" 
                            [ngModel]="selectedOrganization.city"
                            (ngModelChange)="selectedOrganization.city = $event" 
                            name="city" 
                            id="selectedOrganization.city">
                        <span *ngIf="showEditOrganizationError(city)" class="validation-error">Invalid</span>
                    </div>
                    <div class="col-3">
                        <span class="label" name="stateAbbreviation">State</span>
                        <select #stateAbbreviation 
                            required 
                            [(ngModel)]="states" 
                            name="stateAbbreviation" 
                            id="stateAbbreviation">
                            <option value="" hidden></option>
                            <option *ngFor="let state of states" [value]="state.id">
                                {{ state.abbreviation }}
                            </option>
                        </select>
                        <span *ngIf="showEditOrganizationError(stateAbbreviation)" class="validation-error">Invalid</span>
                    </div>
                    <div class="col-3">
                        <span class="label" for="zip">Zip</span>
                        <input #zip 
                            class="mr-2" 
                            type="text" 
                            [ngModel]="selectedOrganization.zip"
                            (ngModelChange)="selectedOrganization.zip = $event" 
                            name="zip" 
                            id="selectedOrganization.zip">
                        <span *ngIf="showEditOrganizationError(zip)" class="validation-error">Invalid</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-1">
                    <span class="label" for="email">Email</span>
                    <input #email  
                        type="text" 
                        [ngModel]="selectedOrganization.email"
                        (ngModelChange)="selectedOrganization.email = $event" 
                        name="email" 
                        id="selectedOrganization.email">
                    <span *ngIf="showEditOrganizationError(email)" class="validation-error">Invalid</span>
                </div>
                <div class="col-1">
                    <span class="label" for="phone">Phone</span>
                    <input #phone 
                        type="text" 
                        [ngModel]="selectedOrganization.phone"
                        (ngModelChange)="selectedOrganization.phone = $event" 
                        name="phone" 
                        id="selectedOrganization.phone">
                    <span *ngIf="showEditOrganizationError(phone)" class="validation-error">Invalid</span>
                </div>
                <div class="col-1">
                    <span class="label" for="fax">Fax</span>
				    <input #fax 
                        type="text" 
                        [ngModel]="selectedOrganization.fax"
					    (ngModelChange)="selectedOrganization.fax = $event" 
                        name="fax" 
                        id="selectedOrganization.fax">
                    <span *ngIf="showEditOrganizationError(fax)" class="validation-error">Invalid</span>
                </div>
                <div class="col-1">
                    <span class="label" for="webSite">Website</span>
				    <input #webSite 
                        type="text" 
                        [ngModel]="selectedOrganization.webSite"
					    (ngModelChange)="selectedOrganization.webSite = $event" 
                        name="webSite" 
                        id="selectedOrganization.webSite">
                    <span *ngIf="showEditOrganizationError(webSite)" class="validation-error">Invalid</span>
                </div>
            </div>
            <div class="row">
                <div class="col-1">
                    <span class="label" for="numberOfBeds">Number Of Beds</span>
                    <input #numberOfBeds 
                        type="number" 
                        [ngModel]="selectedOrganization.numberOfBeds"
                        (ngModelChange)="selectedOrganization.numberOfBeds = $event" 
                        name="numberOfBeds"
                        id="selectedOrganization.numberOfBeds">
                    <span *ngIf="showEditOrganizationError(numberOfBeds)" class="validation-error">Invalid</span>
                </div>
                <div class="col-1">
                    <span class="label" for="isEmailRegistrationEnabled">Is Email Registration Enabled?</span>
					<input #isEmailRegistrationEnabled 
                        type="checkbox"
						[ngModel]="selectedOrganization.isEmailRegistrationEnabled"
						(ngModelChange)="selectedOrganization.isEmailRegistrationEnabled = $event" 
                        name="isEmailRegistrationEnabled"
						id="selectedOrganization.isEmailRegistrationEnabled">
                    <span *ngIf="showEditOrganizationError(isEmailRegistrationEnabled)" class="validation-error">Invalid</span>
                </div>                
            </div>
            <div class="row">
                <div class="col-1">
                    <span class="label" for="isLdapAuthentication">Is LDAP Authentication?</span>
					<input #isLdapAuthentication 
                        type="checkbox"
						[ngModel]="selectedOrganization.isLdapAuthentication"
						(ngModelChange)="selectedOrganization.isLdapAuthentication = $event" 
                        name="isLdapAuthentication"
						id="selectedOrganization.isLdapAuthentication">
                    <span *ngIf="showEditOrganizationError(isLdapAuthentication)" class="validation-error">Invalid</span>
                </div>
                <div class="col-1">
                    <span class="label" for="isSAMLEnabled">Is SAML Enabled?</span>
					<input #isSAMLEnabled 
                        type="checkbox" 
                        [ngModel]="selectedOrganization.isSAMLEnabled"
						(ngModelChange)="selectedOrganization.isSAMLEnabled = $event" 
                        name="isSAMLEnabled"
						id="selectedOrganization.isSAMLEnabled">
                    <span *ngIf="showEditOrganizationError(isSAMLEnabled)" class="validation-error">Invalid</span>
                </div>
            </div>
            <div class="row">
                <div class="col-1">
                    <span class="label" for="isSecureEmail">Is Secure Email?</span>
					<input #isSecureEmail 
                        type="checkbox" 
                        [ngModel]="selectedOrganization.isSecureEmail"
						(ngModelChange)="selectedOrganization.isSecureEmail = $event" 
                        name="isSecureEmail"
						id="selectedOrganization.isSecureEmail">
                    <span *ngIf="showEditOrganizationError(isSecureEmail)" class="validation-error">Invalid</span>
                </div>
                <div class="col-1">
                    <span class="label" for="allowForgotPasswordByEmail">Allow Forgot Password by Email?</span>
					<input #allowForgotPasswordByEmail 
                        type="checkbox"
						[ngModel]="selectedOrganization.allowForgotPasswordByEmail"
                        (ngModelChange)="selectedOrganization.name = $event"
						name="allowForgotPasswordByEmail" 
                        id="selectedOrganization.allowForgotPasswordByEmail">
                    <span *ngIf="showEditOrganizationError(allowForgotPasswordByEmail)" class="validation-error">Invalid</span>
                </div>
            </div>
        </div>
        
        <div class="form-group" *ngIf="_organizationService.isVMorLEMSelected && isHuronAdmin()">
            <span class="label" for="selectedOrganization.lemfyMonthStarting">LEM Fiscal Year Starting Month</span>
            <input #lEMFYMonthStarting 
                class="mr-2"
                type="number" 
                min="1" 
                max="12"
                [ngModel]="selectedOrganization.lemfyMonthStarting"
                (ngModelChange)="selectedOrganization.lemfyMonthStarting = $event;onEdited()" 
                name="lEMFYMonthStarting"
                id="selectedOrganization.lemfyMonthStarting"                 
                required>
            <span *ngIf="showEditOrganizationError(lEMFYMonthStarting)" class="validation-error">Month is required, must be between 1 and 12.</span>
        </div>
    </div>
</form>